module.exports = __webpack_public_path__ + "static/img/3.af98686.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/3.jpg
// module id = m4mq
// module chunks = 1